import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';
import diff from 'object-diff';
import TourEditForm from './TourEditForm';

class TourEditModal extends React.Component {
  constructor(props) {
    super(props);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.requestTourManagers();
  }

  handleSubmit(values) {
    const initialValues = this.props.tour;
    const isNew = this.props.tour.id ? false : true;
    if (isNew) {
      return this.handleAddTour(values, initialValues);
    }
    return this.handleEditTour(values, initialValues);
  }
  handleAddTour(values, initialValues) {
    this.props.addTour(values);
    this.props.onClose();
  }
  handleEditTour(values, initialValues) {
    const submitValues = diff(initialValues, values);
    this.props.editTour(this.props.tour.id, submitValues);
    this.props.onClose();
  }
  handleCancel(event) {
    event.preventDefault();
    this.props.onClose();
  }
  handleAdd(event) {
    event.preventDefault();
    this.props.onClose();
  }
  render() {
    const isNew = this.props.tour.id ? false : true;
    const modalLabel = isNew ? 'Start New Travel Plan' : 'Edit';

    return (
      <Modal show={this.props.show} onHide={this.props.onClose}>
        <Modal.Header closeButton>
          <Modal.Title>{modalLabel}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TourEditForm
            tour={this.props.tour}
            initialValues={this.props.tour}
            onSubmit={this.handleSubmit}
            isNew={isNew}
            tourManagers = {this.props.tourManagers}
            onCancel = {this.props.onClose}
          />
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    );
  }
}

TourEditModal.propTypes = {
  tour: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.String,
    tag_line: PropTypes.String,
  }).isRequired,
  show: PropTypes.bool.isRequired,
  addTour: PropTypes.func.isRequired,
  editTour: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default TourEditModal;



// WEBPACK FOOTER //
// src/routes/tours/components/TourEditModal.js